import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactEditComponent } from './contact-edit.component';
import { CompanyContactModule } from "../../company-contact/company-contact.module";
import { ContactFeeModule } from './contact-fee/contact-fee.module';
import { ContactEditFormModule } from './contact-edit-form/contact-edit-form.module';
import { ContactInformationModule } from '../contact-information/contact-information.module';
import { ContactPlaceListModule } from '../contact-place-list/contact-place-list.module';
import { ContactDuplicateConfirmationDialogModule } from './contact-duplicate-confirmation-dialog/contact-duplicate-confirmation-dialog.module';

/**
 * Modulo per ContactEditComponent
 * 
 * Importa tutti i componenti necessari per la gestione completa dei Contact:
 * - ContactEditFormModule: Form principale
 * - ContactInformationModule: Gestione informazioni contatto
 * - ContactPlaceListModule: Gestione sedi/luoghi
 * - CompanyContactModule: Relazioni con le company
 * - ContactFeeModule: Gestione tariffe
 * - ContactDuplicateConfirmationDialogModule: Modale per conferma duplicati
 */
@NgModule({
  declarations: [
    ContactEditComponent
  ],
  imports: [
    CommonModule,
    ContactEditFormModule,
    ContactInformationModule,
    ContactPlaceListModule,
    CompanyContactModule,
    ContactFeeModule,
    ContactDuplicateConfirmationDialogModule  // ← Importo il module separato invece di dichiarare il component
  ],
  exports: [
    ContactEditComponent
  ]
})
export class ContactEditModule {
}
